import { Box, Stack, Typography } from '@mui/material';

const DemographicCard: React.FC<{
  icon: React.ReactNode;
  label: string;
  value: number | string;
  percentage?: string;
  color: string;
}> = ({ icon, label, value, percentage, color }) => (
  <Stack alignItems="center" spacing={1}>
    <Box
      sx={{
        backgroundColor: color,
        borderRadius: '50%',
        width: 56,
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 1,
      }}
    >
      {icon}
    </Box>
    <Typography variant="subtitle2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1" fontWeight={600}>
      {value}
    </Typography>
    {percentage && (
      <Typography variant="caption" color="text.secondary">
        {percentage}
      </Typography>
    )}
  </Stack>
);

export default DemographicCard;
